export default {
  setSummary: (state, data) => (state.summary = data),
  setSellers: (state, data) => (state.adminSellers = data),
  toggleLoading: state => (state.loading = !state.loading),
  reset: (state, data) => Object.assign(state, data),
  changeSeller: (state, data) => (state.seller = data)
}
